import { Box, Typography, useTheme } from "@mui/material";

import { SELECTION_DRAWER_WIDTH } from "./constants";
import { SelectionSidebar } from "./SelectionSidebar";
import { SelectedObject, SidebarContext } from "./types";

type SelectionDrawerProps = {
  context: SidebarContext;
  objects: SelectedObject[];
  onGalleryOpen?: () => void;
  isGalleryOpen?: boolean;
  onClose: () => void;
  onReloadObjects?: () => void;
};

export const SelectionDrawer = (props: SelectionDrawerProps) => {
  const theme = useTheme();

  const isEmpty = !props.objects?.length;

  return (
    <Box
      sx={{
        width: SELECTION_DRAWER_WIDTH,
        height: "100%",
        overflow: "auto",
        flexShrink: 0,
        borderLeft: `solid 1px ${theme.palette.secondary[6]}`,
        backgroundColor: theme.palette.secondary[8],
        borderRadius: "4px",
        transition: "width 300ms ease",
      }}
    >
      {isEmpty && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <Typography>No selection</Typography>
        </Box>
      )}
      <SelectionSidebar
        context={props.context}
        objects={props.objects}
        isGalleryOpen={props.isGalleryOpen}
        isShowingActions={true}
        isShowingPreview={true}
        sessionId={undefined}
        onCloseDialog={props.onClose}
        onReloadObjects={props.onReloadObjects}
        onClickPreview={() => props.onGalleryOpen?.()}
      />
    </Box>
  );
};
